module.exports = __webpack_public_path__ + "img/workflow-icon-new-gray.bfebbf43.svg";